var exports = {
  "kL": "xdbfd91f1--44c345--container",
  "We": "xdbfd91f1--44c345--container--big",
  "Wu": "xdbfd91f1--44c345--main_container",
  "DD": "xdbfd91f1--44c345--title",
  "h_": "xdbfd91f1--44c345--description",
  "KI": "xdbfd91f1--44c345--icon_container",
};

module.exports = exports;
